import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Ornament } from './Ornament';
const chooseBy = ['student level', 'body focus', 'class objective', 'intensity', 'equipment', 'balance demand', 'progression stage', 'available teaching time'];
const classesCover = ['Beginner Barre', 'Glutes', 'Thighs', 'Inner thighs', 'Outer thighs', 'Calves', 'Relevé', 'Core', 'Balance', 'Stability', 'Upper body', 'Posture', 'Cardio Barre', 'Full-body Barre', 'Mini-band work', 'Barre ball work', 'Standing classes', 'Mat integration', 'Pulse and hold', 'Slow-control work', 'Progressive classes', 'Mixed-level adaptations'];
export function ClassLibrary() {
  return <section className="bg-background px-4 py-20 sm:py-28" data-id="element-53" data-mp="c31jmzvdp7fi">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-54" data-mp="2rrjpxbm47q0h">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-55" data-mp="2wsh4le7x21x8">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-56" data-mp="14pxub92o6qw5">
            150 ready-to-teach Barre classes
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-foreground sm:text-4xl" data-id="element-57" data-mp="1emu21ckqv8zn">
            Stop Planning Every Session From an{' '}
            <span className="italic text-primary" data-id="element-58" data-mp="1skr3ama583kn">Empty Page</span>
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-59" data-mp="1nm7bw6cs5zkw" />
          <p className="mt-5 text-base leading-7 text-muted-foreground" data-id="element-60" data-mp="22c5899kv5vl6">
            This is the practical heart of Barre Instructor Ready. Across the
            complete 6-in-1 system, you receive:
          </p>
          <div className="mt-6 flex items-center gap-5 border-y border-accent/30 py-6" data-id="element-61" data-mp="2bcjtk8xtvaoo">
            <span className="font-display text-6xl font-semibold leading-none text-primary" data-id="element-62" data-mp="27b8546qowvi2">
              150
            </span>
            <span className="text-sm font-semibold uppercase leading-6 tracking-[0.08em] text-foreground" data-id="element-63" data-mp="2ef7lp82qsswy">
              Structured Barre classes
              <span className="block font-medium normal-case tracking-normal text-muted-foreground" data-id="element-64" data-mp="2jbet75asech0">
                ready to use.
              </span>
            </span>
          </div>
          <p className="mt-6 text-sm font-semibold text-foreground" data-id="element-65" data-mp="2t4n8kcz5ke7d">
            Choose according to:
          </p>
          <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-66" data-mp="2x70g96xgmm6s">
            {chooseBy.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-muted-foreground" data-id="element-67" data-mp="3733q6yyjzp4a">
                <CheckIcon size={16} className="mt-1 shrink-0 text-success" aria-hidden="true" data-id="element-68" data-mp="3c15a1m3szsgt" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="self-start rounded-2xl border border-accent/30 bg-surface p-6 shadow-card sm:p-9" data-id="element-69" data-mp="3uyf4eaowo4xf">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary" data-id="element-70" data-mp="3h83bi9khy258">
            Classes cover:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-71" data-mp="hr3zs8dngnct">
            {classesCover.map(item => <li key={item} className="rounded-full border border-primary/20 bg-surface-subtle px-3 py-1.5 text-xs font-medium text-foreground" data-id="element-72" data-mp="dr39nqh6unpx">
                {item}
              </li>)}
          </ul>
          <div className="mt-8 border-t border-accent/25 pt-6" data-id="element-73" data-mp="2thprn6c2f9lq">
            <p className="text-sm font-medium text-muted-foreground" data-id="element-74" data-mp="2oicv1tve6o5y">
              Instead of asking:
            </p>
            <p className="mt-1 font-display text-xl font-medium italic leading-8 text-foreground" data-id="element-75" data-mp="g951ll11csos">
              “What am I teaching tomorrow?”
            </p>
            <p className="mt-3 text-base leading-7 text-foreground" data-id="element-76" data-mp="l2hp1rtzatfy">
              Open the system and already have a{' '}
              <span className="font-semibold text-primary" data-id="element-77" data-mp="c832d474cgmt">
                structured starting point.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}